import type { TreeSelectOption } from 'naive-ui'

function isValidObject(data: unknown): data is Record<string, any> {
  return data !== null && typeof data === 'object' && !Array.isArray(data)
}

function sortEntriesAlphabetically(entries: [string, any][]): [string, any][] {
  return entries.sort(([a], [b]) => a.toLowerCase().localeCompare(b.toLowerCase()))
}

export function transformToArrayTree(data: Record<string, any>, parentKey: string = ''): TreeSelectOption[] {
  if (!isValidObject(data)) return []
  const result: TreeSelectOption[] = []
  const entries = sortEntriesAlphabetically(Object.entries(data))

  for (const [key, value] of entries) {
    if (key.includes(' ')) continue
    const newKey = parentKey ? `${parentKey}.${key}` : key

    if (Array.isArray(value)) {
      result.push({ label: key, key: newKey })
    } else if (value && typeof value === 'object') {
      const children = transformToArrayTree(value, newKey)
      if (children.length > 0) {
        result.push({ label: key, key: newKey, children })
      }
    }
  }

  return result
}

export function transformToTree(
  data: Record<string, any>,
  parentKey: string = '',
  arrayDict: Record<string, any> = {},
): {
  options: TreeSelectOption[]
  arrayDict: Record<string, any>
} {
  if (!isValidObject(data)) return { options: [], arrayDict }
  const result: TreeSelectOption[] = []
  const entries = sortEntriesAlphabetically(Object.entries(data))

  for (const [key, value] of entries) {
    if (key.includes(' ')) continue
    const newKey = parentKey ? `${parentKey}.${key}` : key
    if (Array.isArray(value)) {
      arrayDict[newKey] = value
    }
    const children =
      value && typeof value === 'object' && !Array.isArray(value)
        ? transformToTree(value, newKey, arrayDict).options
        : []
    if (children.length > 0 || !(value && typeof value === 'object' && !Array.isArray(value))) {
      result.push(children.length > 0 ? { label: key, key: newKey, children } : { label: key, key: newKey })
    }
  }
  return { options: result, arrayDict }
}
